<script module lang="ts">
  export interface SearchRecommendationItemProps {
    text: string;
    partialText: string;
    href?: string;
    loading?: boolean;
    css?: SystemStyleObject;
  }
</script>

<script lang="ts">
  import { page } from '$app/state';

  import { getContext } from 'svelte';

  import { css } from '@agapi/ui/panda/css';
  import type { SystemStyleObject } from '@agapi/ui/panda/types';
  import { box, stack, type StackStyles } from '@agapi/ui/panda/patterns';
  import type { NavbarStore } from '@agapi/ui/navbar';

  import { rewriteUrl } from '../../../utils';

  const { text, partialText, href, loading = false, css: cssProp, ...restProps }: SearchRecommendationItemProps = $props();

  const index = text.toLowerCase().indexOf(partialText.toLowerCase());
  const beforeText = text.slice(0, index);
  const boldText = text.slice(index, index + partialText.length);
  const afterText = text.slice(index + partialText.length);

  const navbar = getContext<NavbarStore>('navbar');
</script>

<a href={rewriteUrl(page, href)} onclick={(_ev) => { navbar.closeSearch(); }}>
  <div
    {...restProps}
    class={stack({
      py: '2',
      transition: '0.15s ease',
      'a &': {
        color: 'action.primary.text.foreground.default'
      },
      'a:hover &': {
        color: 'action.primary.text.foreground.hover'
      },
      'a:active &': {
        color: 'action.primary.text.foreground.active'
      },
      maxWidth: { md: 'containers.xs' },
      ...cssProp as StackStyles
    })}
  >
    {#if loading}
      <div class={box({ width: '40%', height: '14px', my: '2', bg: 'grey.100', borderRadius: '99' })}></div>
    {:else}
      <span class={css({ lineClamp: '2' })}>
        {#if text.toLowerCase().includes(partialText.toLowerCase())}
          {beforeText}<span class={css({ fontWeight: 'bold' })}>{boldText}</span>{afterText}
        {:else}
          {text}
        {/if}
      </span>
    {/if}
  </div>
</a>
